module.exports = __webpack_public_path__ + "static/media/logo-icesi.d80994e3.png";